import { render } from "./ToggleBtn.vue?vue&type=template&id=20b4168e&scoped=true"
import script from "./ToggleBtn.vue?vue&type=script&lang=js"
export * from "./ToggleBtn.vue?vue&type=script&lang=js"

import "./ToggleBtn.vue?vue&type=style&index=0&id=20b4168e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b4168e"]])

export default __exports__